import { Injector } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export let AppInjector: Injector;

export function setAppInjector(injector: Injector) {
  AppInjector = injector;
}
